import type { OperationalStatusEnum } from 'fleet-data-model';

export const INVENTORY_V2_PAGE_SIZE = 50;

export const INVENTORY_V2_PREFETCH_ROWS = INVENTORY_V2_PAGE_SIZE;

export const INVENTORY_V2_FIRST_ROW_MARK = 'inventory:first-row';

export const INVENTORY_V2_FILTER_KEYS = [
  'asset_type',
  'device_type',
  'subcategory',
  'robotic_mower_status',
  'operational_status',
  'secondary_status',
  'inventory_status',
  'maintenance_reminder_status',
  'maintenance_status',
  'firmware_update_approved_state',
  'tags',
  'tag_operator',
  'asset_tags',
  'asset_tags_operator',
  'last_seen',
  'last_seen_operator',
  'free_text',
] as const;

export type InventoryV2FilterKey = (typeof INVENTORY_V2_FILTER_KEYS)[number];

/**
 * Filter selection in the same shape the current inventory keeps in `?filters=<json>`,
 * so links and bookmarks work on both pages.
 */
export type InventoryV2FilterValues = Partial<Record<InventoryV2FilterKey, string[] | string>>;

export type InventoryV2FilterParams = Partial<Record<`filter[${InventoryV2FilterKey}]`, string>>;

export interface InventoryV2PageArgs {
  filters: InventoryV2FilterParams;
  skip: number;
}

/** Most map-picked assets pinned on top of the list; the rest stay selected without a pinned row. */
export const INVENTORY_V2_MAX_PINS = 500;

export interface InventoryV2PinArgs {
  filters: InventoryV2FilterParams;
  iprIds: string[];
}

/**
 * An asset selected on the map before the list has loaded its row: the fields `/assets/map`
 * already holds for its marker.
 */
export interface InventoryV2MapSeed {
  iprId: string;
  name: string;
  assetType?: string;
  shortGenericName?: string;
  subcategoryIcon?: string;
  operationalStatus?: OperationalStatusEnum;
}
